import { withProps } from 'recompose';
import MatrixQuestion from './MatrixQuestion';
import MatrixMultiGroupField from './matrixTable/taker/MatrixMultiGroupField';

export default withProps({
  inputRowField: MatrixMultiGroupField,
})(MatrixQuestion);
